import { render, staticRenderFns } from "./CompanyProfileSettings.vue?vue&type=template&id=3f85ab62&scoped=true&"
import script from "./CompanyProfileSettings.vue?vue&type=script&lang=js&"
export * from "./CompanyProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfileSettings.vue?vue&type=style&index=0&id=3f85ab62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85ab62",
  null
  
)

export default component.exports